import { useLocation, Navigate, Outlet } from 'react-router-dom';
import useAuthContext from '../hooks/useAuthContext';

type Props = {
  children?: JSX.Element;
};

const PublicRoute = ({ children }: Props) => {
  const { isAuthenticated } = useAuthContext();
  let location = useLocation();

  if (isAuthenticated) {
    const redirectLocation = location.state?.from || '/';
    return <Navigate to={redirectLocation} />;
  }

  return children ? children : <Outlet />;
};

export default PublicRoute;
